
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination, Autoplay } from 'swiper'
import { Swiper } from 'swiper/react'
import { RightOutlined, LeftOutlined } from '@ant-design/icons'
import { ReactNode, useState } from 'react'

/**
 * @loop 是否循环播放
 * @pagination 是否展示Dot分页器
 * @slidesPerView 一行显示几个，如需要最后一个元素遮盖可加上小数点
 * @children ReactNode
 */
interface propsVoid {
  autoplay?: boolean;
  delay?: number;
  height?: number,
  hideArrows?: boolean
  direction?: string
  loop?: boolean,
  pagination?: boolean,
  slidesPerView: number,
  slidesPerGroup?: number
  children: ReactNode,
  slideChange?: Function
}

export default function SwiperSelf(props: propsVoid) {
  const [swiper, setSwiper]: any = useState(null)
  const [isFirstPage, setIsFirstPage] = useState<boolean>(true)
  const [isLastPage, setIsLastPage] = useState<boolean>(false)

  const handleSlideChange = (event: any) => {
    // Update isFirstPage and isLastPage states
    setIsFirstPage(event.isBeginning);
    setIsLastPage(event.isEnd);

    if (props.slideChange) {
      props.slideChange(event.isBeginning, event.isEnd);
    }
  }

  return (
    <div className='swiperSelf'>
      <Swiper
        className='swiper-no-swiping'
        modules={[ Pagination, Autoplay ]}
        height={props.height || null}
        style={{ width: 'calc(100% - 72px)', height: props.height ? props.height + 'px' : 'auto' }}
        loop={ props.loop ? true : false }
        direction={props.direction === 'vertical' ? 'vertical' : 'horizontal'}
        pagination={ props.pagination ? { clickable: true } : false }
        autoplay={ props.autoplay ? { delay: props.delay || 4000 } : false }
        slidesPerView={props.slidesPerView}
        slidesPerGroup={props.slidesPerGroup || parseInt(`${props.slidesPerView}`)}
        onSwiper={(swiper) => setSwiper(swiper)}
        onSlideChange={handleSlideChange}
      >
        {props.children}
      </Swiper>
      {
        !props.hideArrows &&
        <>
          <div className="swiper-small-wrapper-prev" onClick={() => { swiper.slidePrev(); }}>
            <LeftOutlined 
              style={{ color: isFirstPage ? '#dedede' : '#666666' }}
              className="prev-icon"
            />
          </div>
          <div className="swiper-small-wrapper-next" onClick={() => { swiper.slideNext(); }}>
            <RightOutlined
              style={{ color: isLastPage ? '#dedede' : '#666666' }}
              className="next-icon"
            />
          </div>
        </>
      }
    </div>
  )
}